/**
 * Protected Route component that requires authentication.
 */
import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import { useAuthConfig } from '../contexts/AuthContext';
import LoginComponent from './LoginComponent';

const ProtectedRoute = ({ children, fallback = null }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { isConfigured, isLoading: configLoading } = useAuthConfig();

  // Ładowanie konfiguracji
  if (configLoading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
        flexDirection="column"
        gap={2}
      >
        <CircularProgress size={40} />
        <Typography variant="body1" color="text.secondary">
          Inicjalizacja aplikacji...
        </Typography>
      </Box>
    );
  }

  // Uwierzytelnianie nie skonfigurowane - w trybie DEV pokaż bezpośrednio zawartość
  if (!isConfigured) {
    // Tryb DEV bez autoryzacji - pokaż aplikację
    if (process.env.REACT_APP_DISABLE_AUTH === 'true') {
      console.log('🔓 Rendering app without authentication (DEV mode)');
      return <>{children}</>;
    }
    // Produkcja - pokaż ekran logowania
    return <LoginComponent />;
  }

  // Ładowanie stanu uwierzytelniania
  if (isLoading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
        flexDirection="column"
        gap={2}
      >
        <CircularProgress size={40} />
        <Typography variant="body1" color="text.secondary">
          Sprawdzanie uwierzytelniania...
        </Typography>
      </Box>
    );
  }

  // Użytkownik nie jest zalogowany
  if (!isAuthenticated) {
    return fallback || <LoginComponent />;
  }

  // Użytkownik jest zalogowany - pokaż chronioną zawartość
  return <>{children}</>;
};

export default ProtectedRoute;